import request from "@/utils/request";

/** 查询可用币种 GET /api/v1/sys/getCurrencyList */
export async function getCurrencyList() {
  return request<{ list: string[] }>("/api/v1/sys/getCurrencyList", {
    method: "GET",
  });
}

/** 支持语言项 */
export interface SupportLangItem {
  code: string;
  language: string;
}

/** 查询支持语言列表 GET /api/v1/sys/listSupportLanguage */
export async function listSupportLanguage() {
  return request<{ list: SupportLangItem[] }>(
    "/api/v1/sys/listSupportLanguage",
    {
      method: "GET",
    },
  );
}

/** 上传图片 POST /api/v1/sys/uploadObject */
export async function uploadObject(data: FormData) {
  return request<{ fileUrl?: string; url?: string }>(
    "/api/v1/sys/uploadObject",
    {
      method: "POST",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
}

/** 谷歌验证获取临时票据 POST /api/v1/sys/verifyGoogleCode */
export async function verifyGoogleCode(data: { googleCode: number }) {
  return request<{
    isOpenGoogleCheck: boolean;
    googleUrl: string;
    verifyToken: string;
  }>("/api/v1/sys/googleVerify", {
    method: "POST",
    data,
  });
}

/** 代理树节点 */
export interface AgentTreeItem {
  id: number;
  pid: number;
  appid: string;
  operatorName: string;
  fee: number;
  children?: AgentTreeItem[];
}

/** 获取代理树 GET /api/v1/sys/listOperatorAgentTree */
export async function listOperatorAgentTree() {
  return request<{ list: AgentTreeItem[] }>(
    "/api/v1/sys/listOperatorAgentTree",
    {
      method: "GET",
    },
  );
}

/** 字典项 */
export interface DictItem {
  /** 枚举key */
  dictLabel: string;
  /** 枚举值 */
  dictValue: string;
  [property: string]: any;
}

/** 获取公共枚举 GET /api/v1/sys/getDict */
export async function getDict(params: { dictType: string }) {
  return request<{ list: DictItem[] }>("/api/v1/sys/getDict", {
    method: "GET",
    params,
  });
}
